module.exports = __webpack_public_path__ + "static/media/02-PaddockFencing.798062a0.gif";